// Helper to build a fully-qualified URL for backend-served assets (e.g. logos
// returned as "/api/uploads/xxx.png"). Absolute URLs and data-URLs are
// returned unchanged so callers can pass any source.
//
// The `/api/uploads/*` endpoint is authenticated. Since <img> tags cannot set
// custom headers, we append the current auth token as a `?token=` query
// parameter which the backend also accepts.
import { getToken } from "./api";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const assetUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("data:")) return path;
  const p = path.startsWith("/") ? path : `/${path}`;
  let url = `${BASE}${p}`;
  if (p.startsWith("/api/uploads/")) {
    const tok = getToken();
    if (tok) {
      url += (url.includes("?") ? "&" : "?") + "token=" + encodeURIComponent(tok);
    }
  }
  return url;
};

// Full-name helper: "First Last (username)" if any of first/last present,
// otherwise just "username".
export const displayUserName = (u) => {
  if (!u) return "";
  const first = (u.first_name || "").trim();
  const last = (u.last_name || "").trim();
  const full = [first, last].filter(Boolean).join(" ");
  return full ? `${full} (${u.username})` : u.username;
};
